module.exports = __webpack_public_path__ + "ebd68e11bb402e4b06535de1be21e3d2.svg";